// extracted by mini-css-extract-plugin
module.exports = {"portfoliosContainer":"viewPortfolios_portfoliosContainer__1TwW9","headerContainer":"viewPortfolios_headerContainer__3nLh1"};